import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/sales/";
const url = apiUrl + endPoint;

export async function getItems() {
  return await http.get(url + "/items");
}

export async function getCustomerInvoices(customerId) {
  return await http.get(url + "/customer/" + customerId);
}

export async function getInvoice(invoiceId, role) {
  if (role === "Admin")
    return await http.get(url + "/getCustomerSale/" + invoiceId);
  else return await http.get(url + "/getSale/" + invoiceId);
}

export async function addSale(sale) {
  const payload = { ...sale };
  const sendEmail = payload.sendEmail;
  delete payload.sendEmail;

  return await http.post(url + "add-sale-invoice/" + sendEmail, payload);
}

export async function addInvoice(payload) {
  return await http.post(url + "add-invoice", payload);
}

export async function downloadInvoice(payload) {
  const headers = {
    "Content-Type": "application/json",
  };
  return await http.post(url + "download-invoice/", payload, {
    responseType: "blob",
    headers,
  });
}

// export async function updateTariff(tariff) {
//   const payload = { ...tariff };
//   const oltId = payload._id;
//   delete payload._id;
//   return await http.put(url + oltId, payload);
// }
